import type { CardPair } from './types';

export const BUILT_IN_DECKS: Record<string, CardPair[]> = {
  '數學 (加減)': [
    { q: '1 + 1', a: '2' },
    { q: '5 - 2', a: '3' },
    { q: '3 + 4', a: '7' },
    { q: '10 - 5', a: '5' },
    { q: '6 + 6', a: '12' },
    { q: '9 - 3', a: '6' },
    { q: '8 + 2', a: '10' },
    { q: '7 - 0', a: '7' },
  ],
  '數學 (乘除)': [
    { q: '2 x 3', a: '6' },
    { q: '3 x 3', a: '9' },
    { q: '4 x 2', a: '8' },
    { q: '5 x 5', a: '25' },
    { q: '8 ÷ 2', a: '4' },
    { q: '10 ÷ 2', a: '5' },
    { q: '12 ÷ 3', a: '4' },
    { q: '9 ÷ 9', a: '1' },
  ],
  '英文 (動物)': [
    { q: 'Cat', a: '貓' },
    { q: 'Dog', a: '狗' },
    { q: 'Fish', a: '魚' },
    { q: 'Bird', a: '鳥' },
    { q: 'Pig', a: '豬' },
    { q: 'Cow', a: '牛' },
    { q: 'Duck', a: '鴨子' },
    { q: 'Lion', a: '獅子' },
  ],
  '英文 (顏色)': [
    { q: 'Red', a: '紅' },
    { q: 'Blue', a: '藍' },
    { q: 'Green', a: '綠' },
    { q: 'Yellow', a: '黃' },
    { q: 'Black', a: '黑' },
    { q: 'White', a: '白' },
    { q: 'Pink', a: '粉紅' },
    { q: 'Orange', a: '橘' },
  ],
  成語配對: [
    { q: '一石', a: '二鳥' },
    { q: '七上', a: '八下' },
    { q: '三心', a: '二意' },
    { q: '五花', a: '八門' },
    { q: '井底', a: '之蛙' },
    { q: '守株', a: '待兔' },
    { q: '畫蛇', a: '添足' },
    { q: '對牛', a: '彈琴' },
  ],
  '國語 (相反詞)': [
    { q: '大', a: '小' },
    { q: '多', a: '少' },
    { q: '高', a: '矮' },
    { q: '長', a: '短' },
    { q: '黑', a: '白' },
    { q: '快', a: '慢' },
    { q: '新', a: '舊' },
    { q: '上', a: '下' },
  ],
  生活常識: [
    { q: '紅燈', a: '停' },
    { q: '綠燈', a: '行' },
    { q: '過馬路', a: '走斑馬線' },
    { q: '垃圾', a: '丟垃圾桶' },
    { q: '看醫生', a: '生病時' },
    { q: '下雨', a: '帶雨傘' },
    { q: '口渴', a: '喝水' },
    { q: '睡覺', a: '閉眼睛' },
  ],
  注音: [
    { q: 'ㄅ', a: '爸爸' },
    { q: 'ㄆ', a: '葡萄' },
    { q: 'ㄇ', a: '媽媽' },
    { q: 'ㄈ', a: '飛機' },
    { q: 'ㄉ', a: '蛋糕' },
    { q: 'ㄊ', a: '兔子' },
    { q: 'ㄋ', a: '牛奶' },
    { q: 'ㄌ', a: '快樂' },
  ],
  預設: [
    { q: '太陽', a: 'Sun' },
    { q: '月亮', a: 'Moon' },
    { q: '1+2', a: '3' },
    { q: '紅燈', a: '停' },
    { q: '綠燈', a: '行' },
    { q: '左邊', a: 'Left' },
    { q: '右邊', a: 'Right' },
    { q: '大', a: 'Big' },
  ],
};

// 沿用原作 generateLocalPairs 的關鍵字推測邏輯
export function pickFallbackDeck(topic: string): CardPair[] {
  const t = (topic || '').toLowerCase();
  if (t.includes('數') || t.includes('算') || /\d/.test(t)) {
    return BUILT_IN_DECKS['數學 (加減)']!;
  }
  if (t.includes('英') || /[a-z]/.test(t)) return BUILT_IN_DECKS['英文 (動物)']!;
  if (t.includes('動物') || t.includes('叫聲')) return BUILT_IN_DECKS['英文 (動物)']!;
  if (t.includes('成語')) return BUILT_IN_DECKS['成語配對']!;
  if (t.includes('國語') || t.includes('反')) return BUILT_IN_DECKS['國語 (相反詞)']!;
  if (t.includes('注音')) return BUILT_IN_DECKS['注音']!;
  return BUILT_IN_DECKS['預設']!;
}
